import React from "react";

/** Real toggle switch (CSS-driven, see .switch in global.css) — replaces plain checkboxes used as booleans. */
const Switch = ({ checked, onChange, disabled = false }) => (
  <label className="switch">
    <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
    <span className="track" />
  </label>
);

export default Switch;
